import { AxiosResponse } from "axios";
import axiosClient from "@/shared/lib/axios/axios.ts";
import { API_ROUTES } from "@/map/api/config.ts";
import { MapOverlayApiResponse, MapOverlayVersionsApiResponse } from "@/map/types/overlay.ts";

export interface GetMapOverlayInput {
  location_id: number;
  version?: string;
}

export const getMapOverlay = async ({ location_id, version }: GetMapOverlayInput) => {
  const params: Record<string, string | number> = { location_id };
  if (version) {
    params.version = version;
  }

  return axiosClient
    .get<GetMapOverlayInput, AxiosResponse<MapOverlayApiResponse>>(
      `${API_ROUTES.MAP_OVERLAY}/active`,
      { params }
    )
    .then((res) => res.data);
};

export interface GetMapOverlayVersionsInput {
  location_id: number;
}

export const getMapOverlayVersions = async ({ location_id }: GetMapOverlayVersionsInput) => {
  return axiosClient
    .get<GetMapOverlayVersionsInput, AxiosResponse<MapOverlayVersionsApiResponse>>(
      `${API_ROUTES.MAP_OVERLAY}/versions`,
      { params: { location_id } }
    )
    .then((res) => res.data);
};
